export default __webpack_public_path__ + "static/media/left-bottom.ae37fd1c.png";